import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    view: state.pages.productList.view,
});

type Props = ReturnType<typeof mapStateToProps> & WidgetProps;

export interface ProductListControlsContainerStyles {
    container?: GridContainerProps;
    tableViewContainer?: GridContainerProps;
    countGridItem?: GridItemProps;
    countTableViewGridItem?: GridItemProps;
    sortGridItem?: GridItemProps;
    sortTableViewGridItem?: GridItemProps;
    filterGridItem?: GridItemProps;
    filterTableViewGridItem?: GridItemProps;
    viewSelectGridItem?: GridItemProps;
    viewSelectTableViewGridItem?: GridItemProps;
    resultsGridItem?: GridItemProps;
    resultsTableViewGridItem?: GridItemProps;
}

export const controlsContainerStyles: ProductListControlsContainerStyles = {
    container: {
        gap: 0,
        css: css`
            background: #f3f1f1;
            border: 1px solid #d6d6d6;
            padding: 10px 10px;
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css``,
                    css``,
                    css``,
                    css`
                        margin-right: 25px;
                        margin-left: 25px;
                    `,
                    css`
                        margin-right: 25px;
                        margin-left: 25px;
                    `,
                ]);
            }}
            width: auto;
        `,
        offsetProps: {
            style: {
                alignItems: "center",
            },
        },
    },
    tableViewContainer: {
        gap: 0,
        css: css`
            background: #f3f1f1;
            border: 1px solid #d6d6d6;
            padding: 10px 10px;
            width: auto;
        `,
        offsetProps: {
            style: {
                alignItems: "center",
            },
        },
    },
    countGridItem: {
        width: [12, 12, 12, 9, 9],
    },
    countTableViewGridItem: {
        width: [12, 12, 1, 1, 1],
    },
    sortGridItem: {
        width: [12, 12, 12, 6, 3],
        css: css`
            > div {
                text-align: left;
            }
            text-align: left;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            > div {
                                text-align: center;
                            }
                        `,
                    ],
                    "max",
                )}
        `,
    },
    sortTableViewGridItem: {
        width: [12, 12, 3, 3, 3],
        css: css`
            padding-right: 30px;
            > div {
                text-align: left;
            }
            text-align: left;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            > div {
                                text-align: center;
                            }
                        `,
                    ],
                    "max",
                )}
        `,
    },
    filterGridItem: {
        width: 0,
    },
    filterTableViewGridItem: {
        width: [0, 0, 1, 1, 1],
        align: "middle",
        css: css`
            justify-content: center;
        `,
    },
    viewSelectGridItem: {
        width: [0, 0, 0, 6, 4],
    },
    viewSelectTableViewGridItem: {
        width: [0, 0, 3, 3, 3],
    },
    resultsGridItem: {
        width: [12, 12, 12, 12, 5],
    },
    resultsTableViewGridItem: {
        width: [12, 12, 12, 5, 5],
    },
};

const styles = controlsContainerStyles;

const ProductListControlsContainer: FC<Props> = ({ id, view }) => {
    return (
        <GridContainer {...(view === "Table" ? styles.tableViewContainer : styles.container)}>
            <GridItem {...(view === "Table" ? styles.sortTableViewGridItem : styles.sortGridItem)}>
                <Zone contentId={id} zoneName="Content00" />
            </GridItem>
            <GridItem {...(view === "Table" ? styles.viewSelectTableViewGridItem : styles.viewSelectGridItem)}>
                <Zone contentId={id} zoneName="Content01" />
            </GridItem>
            <GridItem {...(view === "Table" ? styles.filterTableViewGridItem : styles.filterGridItem)}>
                <Zone contentId={id} zoneName="Content02" />
            </GridItem>
            <GridItem {...(view === "Table" ? styles.resultsTableViewGridItem : styles.resultsGridItem)}>
                <Zone contentId={id} zoneName="Content03" />
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(ProductListControlsContainer),
    definition: {
        group: "Product List",
        displayName: "List Controls Container",
        allowedContexts: ["ProductListPage"],
    },
};

export default widgetModule;
